import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Header, HeaderProps } from "Components/Layout";

export const GenericHeader: React.FC<HeaderProps> = (props) => {   
   const isVMMobileMenuOpen = useSelector(state => state.mobileMenu.isOpen);
   useEffect(() => {
      if (isVMMobileMenuOpen) {
         document.body.classList.add("page-mobile-menu--open")
         window.scrollTo(0, 0);
      } else {
         document.body.classList.remove("page-mobile-menu--open")
      }            
   }, [isVMMobileMenuOpen])

   return <Header {...props} />;
}